import React, { Component } from 'react';
import axios from 'axios';
import {path,storeImagePath} from './routes.js';
import SelectBox from '../component/Select.js';
import ManageTiers from './ManageTiers.js'; //container for viewing, creating, or editing Tiers
import ManageVirtues from './ManageVirtues.js'; //container for viewing, creating, or editing lov values
import ManageYears from './ManageYears.js'; //container for viewing or creating years
import ManagePrizes from './ManagePrizes.js'; //container for viewing, creating, or editing prizes
import ManageAdminMessages from './ManageAdminMessages.js'; //container for viewing or creating admin messages
import ManageDepartments from './ManageDepartments.js'; //container for viewing or creating departments 
import Submit from '../component/Submit.js';
import Modal from 'react-modal';
import loader from '../asset/img/loader.gif';

export default class AdminCenter extends Component {
	constructor(props){
		super(props);
		this.state ={
			Tiers:[],
			Prizes:[],
			Virtues:[],
			Years:[],
			Messages:[],
			Departments:[],
			departmentInfo:[],
			employees:[],
			category:'Prizes',
			year:'',
			create:false,
			edit:false,
			save:false
		};
		this.handleSelect = this.handleSelect.bind(this);
		this.goBack = this.goBack.bind(this);
		this.onClose = this.onClose.bind(this);
		this.getTiers = this.getTiers.bind(this);
		this.getVirtues = this.getVirtues.bind(this);
		this.getPrizes = this.getPrizes.bind(this);
		this.getMessages = this.getMessages.bind(this);
		this.handleChoice = this.handleChoice.bind(this);
		this.handleSave = this.handleSave.bind(this);
		this.handleReset = this.handleReset.bind(this);
		this.revertSave = this.revertSave.bind(this);
		this.loadingFunc = this.loadingFunc.bind(this);
		this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.getDepartments = this.getDepartments.bind(this);
	}

	getDepartments(){ //method that retrieves and formats all department data from the database
		axios({
			method:'post',
			url:path,
			headers:{'Content-Type':'application/json'},
			data:{endpoint:'info',table:'department',action:'manage'}
		}).then((response)=>{
			let data = response.data.data;
			let departmentNames = []; //list of departments
			let departmentInfo = []; //list of information about departments
			let index;
			for(let i=0;i<data.length;i++){
				index = departmentNames.indexOf(data[i].department);
				if(index !== -1){ //if list of departments already contains department
					if(data[i].name !== data[i].manager){
						departmentInfo[index].employees.push({userID:data[i].userID,name:data[i].name});
					}else{
						departmentInfo[index].manager.userID = data[i].userID;
					}
				}else{
					departmentNames.push(data[i].department);
					if(data[i].name !== data[i].manager){
						departmentInfo.push({department:data[i].department,
																manager:{name:data[i].manager,userID:''},
																employees:[{userID:data[i].userID,name:data[i].name}]
																});
					}else{
						departmentInfo.push({department:data[i].department,manager:data[i].manager,employees:[]});
					}
				}
			}
			this.setState({Departments:departmentNames,departmentInfo:departmentInfo,employees:data});
		});
	}

	loadingFunc(loading){ //method for displaying and closing loading gif
		if(loading){
			this.setState({loading:true},function(){
				this.openModal();
			});
		}else{
			this.setState({loading:false},function(){
				this.closeModal();
			});
		}
	}

	componentDidMount(){//when component mounts, all information regarding prizes/gifts, tiers, admin messages, years, departments, and values are retrieved.
		axios({
			method:'post',
			url:path,headers:{'Content-Type':'application/json'},
			data:{endpoint:'info',table:'years'}
		}).then((response)=>{
			let data = response.data.data;
			this.setState({Years:data,year:data[0].year});
			this.getTiers(data[0].year);
			this.getPrizes(data[0].year);
			this.getMessages(data[0].year);
		});
		this.getDepartments();
		this.getVirtues();
	}

	getTiers(year){ //method that handles retrieving tier information for the selected year from the database.
		axios({
			method:'post',
			url:path,headers:{'Content-Type':'application/json'},
			data:{endpoint:'info',table:'tiers',kind:this.props.app,year:year}
		}).then((response)=>{
			let data = response.data.data;
			this.setState({Tiers:data});
		});
	}

	getVirtues(){ //method that handles retrieving lov values information from the database.
		axios({
			method:'post',
			url:path,headers:{'Content-Type':'application/json'},
			data:{endpoint:'info',table:'virtues',action:'admin'}
		}).then((response)=>{
			let data = response.data.data;
			this.setState({Virtues:data});
		});
	}

	getPrizes(year){ //method that handles retrieving prize/gift information for the selected year from the database.
		this.loadingFunc(true);
		let prizes = [];
		let variants = [];
		axios({
			method:'post',
			url:path,headers:{'Content-Type':'application/json'},
			data:{endpoint:'info',table:'prizes',kind:'lov',action:this.props.userInfo.userType,year:year}
		}).then((response)=>{
		//outer promise
			let data = response.data.data;
			data.forEach((prize)=>{
				prizes.push(Object.assign(prize,{variants:[]}));
			});
			axios({
				method:'post',
				url:path,headers:{'Content-Type':'application/json'},
				data:{endpoint:'info',table:'variants',action:'admin',year:year}
			}).then((response)=>{
				let data = response.data.data;
				data.forEach((variant)=>{
					variants.push(variant);
				});
			}).then(()=>{
				for(let i = 0; i<prizes.length; i++){
					prizes[i].picture = storeImagePath+prizes[i].picture;
						for(let j = 0; j<variants.length; j++){
								if(variants[j].prizeID === prizes[i].prizeID){
									prizes[i].variants.push(variants[j]);
								}
						}
				}
				this.setState({Prizes:prizes},function(){
					this.loadingFunc(false);
				});
			});
		//end outer romise
		});
	}

	getMessages(year){ //method that handles retrieving admin message information for the selected year from the database.
		axios({
			method:'post',
			url:path,headers:{'Content-Type':'application/json'},
			data:{endpoint:'info',table:'messages',action:'admin_center',kind:'admin',year:year}
		}).then((response)=>{
			let data = response.data.data;
			this.setState({Messages:data});
		});
	}

	handleChoice(identity){ //this method controls the state of the admin center, whether it is in view mode, edit mode, or create mode.
		if(identity === "create"){
			this.setState({create:true});
			this.setState({edit:false});
		}else{
			this.setState({edit:true});
			this.setState({create:false});
		}
	}

	handleSelect(identity,value){ //handleChange method for the category and year dropdown menus
		const theState = {};
		theState[identity] = value;
		this.setState(theState);
		if(identity === "year"){
			this.setState({edit:false});
			this.getTiers(value);
			this.getPrizes(value);
			this.getMessages(value);
		}else{
			this.goBack();
		}
	}

	handleReset(type){ //method that grabs the current version of information that was just updated from the database
		
		if(type === "tiers"){
			this.getTiers(this.state.year);
		}else if(type === "prizes"){
			this.getPrizes(this.state.year);
		}else if(type === "virtues"){
			this.getVirtues();
		}else if(type === "years"){
			axios({
				method:'post',
				url:path,headers:{'Content-Type':'application/json'},
				data:{endpoint:'info',table:'years'}
			}).then((response)=>{
				let data=response.data.data;
				this.setState({Years:data,year:data[0].year});
			});
		}else if(type === "messages"){
			this.getMessages(this.state.year);
		}
		this.setState({create:false,edit:false,save:false});
	}

	goBack(){ //method sets the create, edit, and save parts of the state to their defaults
		this.setState({create:false,edit:false,save:false});
	}
	handleSave(){ //method to trigger state change for saving information that has been created or updated
		this.setState({save:true});
	}
	revertSave(){ //method to reset the save parameter of the state to its default
		this.setState({save:false});
	}
	onClose(){ //method that resets create or edit back to default when user exits in the middle of an operation
		this.setState({create:false,edit:false});
	}

	openModal() { //method for opening the modal
	   this.setState({modalIsOpen: true});
	}

	closeModal() { //method for closing the modal
	    this.setState({modalIsOpen: false,submit:false,failed:[]});
	}

	render(){
		const customStyles = {
		  content : {
		    top: '50%',
		    left: '50%',
		    right: 'auto',
		    bottom: 'auto',
		    width:'100%',
		    minWidth:'300px',
		    maxWidth:'400px',
		    minHeight:'250px',
		    maxHeight:'250px',
		    borderStyle:'solid',
		    borderWidth:'2px',
		    borderColor:'gray',
		    transform: 'translate(-50%, -50%)',
		    boxShadow:'0.5px 0.5px 1px 0.5px'
			},  
			overlay:{
				backgroundColor:'rgba(105,105,105,0.8)'
			}
		};
		let dis = false;
		let inlineContent = {boxShadow:'0px 0px 5px 5px #aaaaaa inset',backgroundColor:'#e6e6e6',maxHeight:'450px',overflowY:'auto'};
		let contentStyles = "br3 ba b--gray fl pb4 w-100 pt3 mb3";
		let greaterContent;
		const {Tiers,create,edit,save,year,Virtues,Years,Prizes,Messages} = this.state;
		let content;
		let categories = ["Tiers","Prizes","Values","Messages","Years","Departments"]; //options for category dropdown
		const years = this.state.Years.map((Years)=>{return Years.year}); //returns an array of the current year options for year dropdown
		const selectStyles = "h2 pa1 w-70-ns w-100 br2 bw1 truncate shadow-2";
		const labelStyle = "fl w-30";
		const selectDivStyle = "fl w-70";
		const buttonStyles ="br3 white b w-100 h2 bg-navy shadow-2";
		let prizeTiers = [];
		Tiers.forEach((tiers)=>{ //returns all active tiers for prize/gift creation
			if(tiers.tier_status !== 'inactive'){
				prizeTiers.push(tiers.tier);
			}
		});

		let yearSelect = <div className="fl w-50-ns w-100-m w-100">
															<div className={labelStyle}>
																<label className="b mt2">Year: </label>
															</div>
															<div className={selectDivStyle}>
																<SelectBox identity="year" options={years} onSelect={this.handleSelect} styles={selectStyles} val={this.state.year}/>
															</div>
														</div>;

		let saveButton;
		let createButton = <Submit name="Create" identity="create" onClick={this.handleChoice} styles={buttonStyles}/>; //default create button
		let editButton = <Submit name="Edit" identity="edit" onClick={this.handleChoice} styles={buttonStyles} disable={dis}/>; //default edit button
		if(this.state.create || this.state.edit){
			saveButton = <Submit name="Save" identity="save" onClick={this.handleSave} styles={buttonStyles}/>;
			if(this.state.create){ //if the admin center is in create mode, these are the button values
				editButton = <Submit name="Back" identity="back" onClick={this.goBack} styles={buttonStyles}/>;
				createButton = saveButton;
			}else{ //if the admin center is in edit mode, these are the button values
				if(this.state.category === "Prizes"){
					editButton = <Submit name="Back" identity="back" onClick={this.goBack} styles={buttonStyles}/>;
				}else{
					editButton = saveButton;
					createButton = <Submit name="Back" identity="back" onClick={this.goBack} styles={buttonStyles}/>;
				}
			}
		}
		//button original div that the buttons remain in, can change based on category chosen
		let ButtonGroup = <div className="mb2 mt3" style={{maxWidth:'300px',margin:'auto'}}>
								<div className="fl w-50 tr">
									<div className="tr">
										{createButton}
									</div>
								</div>
								<div className="fl w-50">
									{editButton}
								</div>
							</div>;

		switch(this.state.category){ //switch statement for rendering content based on category selection
			case "Tiers":
				content = <ManageTiers tiers={Tiers} revertSave={this.revertSave} create={create} edit={edit} save={save} year={year} app={this.props.app} reset={this.handleReset}/>;
			break;
			case "Prizes":
				content = <ManagePrizes prizes={Prizes} revertSave={this.revertSave} create={create} edit={edit} save={save} year={year} app={this.props.app} reset={this.getPrizes} onClose={this.onClose} tiers={prizeTiers}/>;
			break;
			case "Values":
				yearSelect = '';
				content = <ManageVirtues virtues={Virtues} revertSave={this.revertSave} create={create} edit={edit} save={save} reset={this.handleReset}/>;
			break;
			case "Messages":
				content = <ManageAdminMessages messages={Messages} years={years} year={year} revertSave={this.revertSave} create={create} edit={edit} save={save} reset={this.getMessages} userInfo={this.props.userInfo}/>
				dis = true;
				if(!this.state.create){ //admin messages dont have an edit option
					ButtonGroup = <div className="mb2 mt3" style={{maxWidth:'300px',margin:'auto'}}>
									<div className="fl w-100">
										<div className="tc w-50 center">
											{createButton}
										</div>
									</div>
								</div>;
				}else{
					ButtonGroup = <div className="mb2 mt3" style={{maxWidth:'300px',margin:'auto'}}>
								<div className="fl w-50 tr">
									<div className="tr">
										{createButton}
									</div>
								</div>
								<div className="fl w-50">
									<Submit name="Back" identity="back" onClick={this.goBack} styles={buttonStyles}/>
								</div>
							</div>;
				}
			break;
			case "Years":
				content = <ManageYears years={Years} year={year} revertSave={this.revertSave} create={create} edit={edit} save={save} reset={this.handleReset}/>
				dis = true;
				yearSelect = '';
				if(!this.state.create){ //years dont have an edit option
					ButtonGroup = <div className="mb2 mt3" style={{maxWidth:'300px',margin:'auto'}}>
									<div className="fl w-100">
										<div className="tc w-50 center">
											{createButton}
										</div>
									</div>
								</div>;
				}else{
					ButtonGroup = <div className="mb2 mt3" style={{maxWidth:'300px',margin:'auto'}}>
								<div className="fl w-50 tr">
									<div className="tr">
										{createButton}
									</div>
								</div>
								<div className="fl w-50">
									<Submit name="Back" identity="back" onClick={this.goBack} styles={buttonStyles}/>
								</div>
							</div>;
				}
			break;
			case "Departments":
				content = <ManageDepartments Add={this.createDepartment} getDepartments={this.getDepartments} create={create} departments={this.state.Departments} employeeList={this.state.employees} departmentInfo={this.state.departmentInfo}/>;
				yearSelect = '';
				if(!this.state.create){ //departments dont have an edit option
					ButtonGroup = <div className="mb2 mt3" style={{maxWidth:'300px',margin:'auto'}}>
									<div className="fl w-100">
										<div className="tc w-50 center">
											{createButton}
										</div>
									</div>
								</div>;
				}else{
					 ButtonGroup = <div className="mb2 mt3" style={{maxWidth:'300px',margin:'auto'}}>
								<div className="fl w-100">
									<div className="w-50 tc center">
										<Submit name="Back" identity="back" onClick={this.goBack} styles={buttonStyles}/>
									</div>
								</div>
							</div>;
				}
			break;
			default:
				content = <ManagePrizes prizes={Prizes} create={create} revertSave={this.revertSave} edit={edit} save={save} year={year} app={this.props.app} reset={this.getPrizes} onClose={this.onClose}/>;
		}
		
		if(this.props.active){
			greaterContent = <div className="fl w-100">
													<div className="fl w-100 mv2 pb3">
														<div className="fl w-50-ns w-100-m w-100 mb1" style={{display:'inline-block'}}>
															<div className={labelStyle}>
																<label className="b mt2">Category: </label>
															</div>
															<div className={selectDivStyle}>
																<SelectBox identity="category" options={categories} onSelect={this.handleSelect} styles={selectStyles} val={this.state.category}/>
															</div>
														</div>
														{yearSelect}
													</div>
													
													<div className={contentStyles} style={inlineContent}>
														{content}
													</div>
													{ButtonGroup}
													<div>
														<Modal
												          isOpen={this.state.modalIsOpen}
												          style={customStyles}
												          contentLabel="loading"
												          shouldCloseOnOverlayClick={false}
												          shouldCloseOnEsc={false}
												        >
												        <div className="fl w-100 tr">
												        	<button className="bg-white gray b br3" onClick={this.closeModal}>X</button>
												        </div>
												        	<div className="tc" style={{width:'150px',margin:'auto'}}><img src={loader} alt="Loading" /></div>
												        </Modal>
													</div>
												</div>;
		}
		return(
			<div>
				{greaterContent}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/container/AdminCenter.js